import {ApiService} from '../ApiService'
import {SubmitXpertKnowledgePublicRatingBody, XpertKnowledgeDto} from '../XpertKnowledge/type'
import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {XpertKnowledgeTutorialDto} from '../XpertKnowledgeTutorial/type'

class XpertKnowledgePublicTutorialServiceProvider extends ApiService {
  async getPublicById(xpertKnowledgeId: string, userUuid: string): Promise<XpertKnowledgeTutorialDto> {
    return this.get<XpertKnowledgeTutorialDto>(`/xpert-knowledge/${xpertKnowledgeId}/public?guid=${userUuid}`)
  }

  async submitPublicRating(body: SubmitXpertKnowledgePublicRatingBody): Promise<XpertKnowledgeTutorialDto> {
    return this.post<XpertKnowledgeTutorialDto>(`/xpert-knowledge/rating/public`, body, undefined)
  }

  async makeTutorialPublic(xpertKnowledgeId: string): Promise<XpertKnowledgeDto> {
    return this.post<XpertKnowledgeDto>(`/xpert-knowledge/view/public?xk_id=${xpertKnowledgeId}`, undefined, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async makeTutorialPrivate(xpertKnowledgeId: string): Promise<XpertKnowledgeDto> {
    return this.post<XpertKnowledgeDto>(`/xpert-knowledge/view/private?xk_id=${xpertKnowledgeId}`, undefined, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const XpertKnowledgePublicTutorialService = new XpertKnowledgePublicTutorialServiceProvider()
